import apiSlice from '../../api/apiSlice';

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    register: builder.mutation({
      query: registerBrandData => ({
        url: 'brands',
        method: 'POST',
        body: registerBrandData,
      }),
      providesTags: ['BrandData'],
    }),
    login: builder.mutation({
      query: loginBrandData => ({
        url: 'brands/login',
        method: 'POST',
        body: loginBrandData,
      }),
      providesTags: ['BrandData'],
    }),
    refreshToken: builder.mutation({
      query: () => ({
        url: 'brands/refresh-token',
        method: 'POST',
      }),
    }),
    getUserBrands: builder.query({
      query: () => 'brands/users/me/brands',
      providesTags: ['UserBrands'],
    }),
    registerBrandUser: builder.mutation({
      query: registerBrandUser => ({
        url: 'brands/register',
        method: 'POST',
        body: registerBrandUser,
      }),
      providesTags: ['BrandData'],
    }),
    update: builder.mutation({
      query: updateBrandData => ({
        url: 'brands',
        method: 'PATCH',
        body: updateBrandData,
      }),
      invalidatesTags: ['BrandData'],
    }),
    getUserData: builder.query({
      query: () => 'brands/users/me',
      providesTags: ['UserData'],
    }),
    updateUser: builder.mutation({
      query: updateUserData => ({
        url: 'brands/users',
        method: 'PATCH',
        body: updateUserData,
      }),
      invalidatesTags: ['UserData'],
    }),
    getBrandData: builder.query({
      query: () => 'brands',
      providesTags: ['BrandData'],
    }),
    getUsersData: builder.query({
      query: () => 'brands/users',
      providesTags: ['UsersData'],
    }),
    getInvitations: builder.query({
      query: () => 'brands/user-invitations',
      providesTags: ['UserInvitations'],
    }),
    createUserInvitation: builder.mutation({
      query: invitationEmails => ({
        url: 'brands/user-invitations',
        method: 'POST',
        body: invitationEmails,
      }),
      invalidatesTags: ['UserInvitations'],
    }),
    resendUserInvitation: builder.mutation({
      query: invitationId => ({
        url: `brands/user-invitations/${invitationId}/resend`,
        method: 'POST',
      }),
      invalidatesTags: ['UserInvitations'],
    }),
    getInvitationById: builder.query({
      query: invitationId => `/brands/user-invitations/${invitationId}`,
      providesTags: ['UserInvitation'],
    }),
    acceptInvitation: builder.mutation({
      query: ({ invitationId, invitationData }) => ({
        url: `brands/user-invitations/${invitationId}/accept`,
        method: 'POST',
        body: invitationData,
      }),
      providesTags: ['BrandData'],
    }),
    getRegions: builder.query({
      query: () => 'brands/regions',
      providesTags: ['RegionsData'],
    }),
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useRefreshTokenMutation,
  useGetUserBrandsQuery,
  useRegisterBrandUserMutation,
  useUpdateMutation,
  useGetBrandDataQuery,
  useUpdateUserMutation,
  useGetUserDataQuery,
  useGetUsersDataQuery,
  useGetInvitationsQuery,
  useCreateUserInvitationMutation,
  useResendUserInvitationMutation,
  useGetInvitationByIdQuery,
  useAcceptInvitationMutation,
  useGetRegionsQuery,
} = authApiSlice;
